<template>
  <div class="tabChatStyle">
    <Row class="tabChatStyleItem" v-if="isLeft">
      <i-col class="tabImg" :xs="5" :sm="5" :md="6" :lg="4">
        <svg class="icon-mpai-colors imgStyle" aria-hidden="true">
          <use :xlink:href="icon"></use>
        </svg>
      </i-col>
      <i-col class="tabFont_Context" span="15">
        <div class="tabFont">
          <div class="tabFontName">{{ name }}</div>
          <div class="tabFontChat">
            {{ tabFontChat }}
          </div>
        </div>
      </i-col>
      <i-col class="tabImg" :xs="2" :sm="2" :md="2" :lg="4"> </i-col>
    </Row>
    <Row class="tabChatStyleItem" v-else>
      <i-col class="tabImg" :xs="3" :sm="3" :md="3" :lg="4"> </i-col>
      <i-col class="tabFont_Context" span="15">
        <div class="tabFont">
          <div class="tabFontName fontRight">{{ name }}</div>
          <div class="tabFontChat">
            {{ tabFontChat }}
          </div>
        </div>
      </i-col>
      <i-col class="tabImg" :xs="5" :sm="5" :md="6" :lg="4">
        <svg class="icon-mpai-colors imgStyle" aria-hidden="true">
          <use :xlink:href="icon"></use>
        </svg>
      </i-col>
    </Row>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: ""
    },
    isLeft: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      default: ""
    },
    tabFontChat: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="less" scoped>
.tabChatStyle {
  width: 100%;
  text-align: right;
  padding: 8px 0;
}
.tabChatStyleItem {
  text-align: left;
  width: 100%;
  display: flex;
  align-items: center;
  .tabImg {
    display: flex;
    justify-content: center;
    align-items: center;
    .imgStyle {
      width: 80%;
      height: 55px;
      width: 55px;
      margin: 10px;
    }
  }
  .tabFont_Context {
    .tabFont {
      font-family: "微软雅黑";
      .fontRight {
        text-align: right;
      }
      .tabFontName {
        font-size: 15px;
        font-weight: bold;
      }
      .tabFontChat {
        font-size: 11px;
        letter-spacing: 1px;
      }
    }
  }
}
.leftPadding {
  padding-left: 10px;
}
</style>
